/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 *
 * TRANSFORMED: This file has been post-processed to support factory pattern.
 * Use createApiClient(customFetch) to create a configured API client instance.
 */
import type { CustomFetchFn } from '../../src/client/types';
import type {
  Activities,
  Activity,
  ActivityDetail,
  ActivityFeaturedResults,
  ActivityId,
  ActivitySearchResults,
  AdminActivitySearchResults,
  ApproveActivityRevisionBody,
  ApproveProfessionalRevisionBody,
  ArchiveSessionBody,
  AssignActivityScopesBody,
  AssignActivityScopesResponse,
  AssignUserGroupsBody,
  AssignUserGroupsResponse,
  BlockProfessionalBody,
  BlockProfessionalResponse,
  BlockUserBody,
  BlockUserResponse,
  BookingResponse,
  CancelSlotOccurrenceBody,
  CancelSubscription200,
  CancelSubscriptionBody,
  CategoryId,
  ChangeSubscriptionPlan200,
  ChangeSubscriptionPlanBody,
  ConfirmBookingBody,
  CreateAccountLink200,
  CreateAccountLinkBody,
  CreateAccountSession200,
  CreateAccountSessionBody,
  CreateActivityBody,
  CreateBillingPortalSession200,
  CreateBillingPortalSessionBody,
  CreateBookingBody,
  CreateCategoryRequest,
  CreateCategoryResponse,
  CreateDashboardLoginLink200,
  CreateDashboardLoginLinkBody,
  CreateGroupRequest,
  CreateGroupResponse,
  CreatePaymentIntent200,
  CreatePaymentIntentBody,
  CreateProfessionalBody,
  CreateReviewBody,
  CreateSavedAddress,
  CreateSessionBody,
  CreateSetupIntent200,
  CreateSetupIntentBody,
  CreateStripeAccount200,
  CreateStripeAccountBody,
  CreateSubscription200,
  CreateSubscriptionBody,
  CreateUserBody,
  DashboardBookingsChartResponse,
  DashboardBookingsResponse,
  DashboardCashflowResponse,
  DashboardEarningsResponse,
  DashboardMenteesResponse,
  DashboardMetricsResponse,
  DashboardOverviewResponse,
  DeclineActivityRevision200,
  DeclineActivityRevisionBody,
  DeclineProfessionalRevisionBody,
  DeleteAssetsBody,
  DeleteBookingParams,
  DeleteBookingResponse,
  DeleteCategoryResponse,
  DeleteGroupResponse,
  DeleteNotification200,
  DeleteNotificationParams,
  DeletePrivateAssetsBody,
  DeleteProfessionalBookingParams,
  DeleteSavedAddress200,
  DeleteSession200,
  GenerateCalendarTokenOutput,
  GetActivitiesAdminParams,
  GetActivitiesFeaturedParams,
  GetActivitiesParams,
  GetActivityByIdParams,
  GetActivityCacheInfo200,
  GetActivityRevisions200Item,
  GetAdminDashboardStats200,
  GetAdminDisputesParams,
  GetAdminDisputesResponse,
  GetAuditEventsParams,
  GetAuditEventsResponse,
  GetAvailableSlotsInput,
  GetAvailableSlotsOutput,
  GetBookingByIdParams,
  GetBookingByIdResponse,
  GetCalendarFeedOutput,
  GetCalendarFeedParams,
  GetDashboardBookingsChartParams,
  GetDashboardCashflowParams,
  GetDashboardOverviewParams,
  GetNotificationPreferences200,
  GetNotificationPreferencesParams,
  GetPrivateAssetUploadUrlBody,
  GetPrivateUserAssetUploadUrl200,
  GetProfessionalActivitiesParams,
  GetProfessionalBookingsParams,
  GetProfessionalBookingsResponse,
  GetProfessionalCacheInfo200,
  GetProfessionalDashboardBookingsParams,
  GetProfessionalDashboardEarningsParams,
  GetProfessionalDashboardMetricsParams,
  GetProfessionalPaymentsDashboard200,
  GetProfessionalsAdminParams,
  GetProfessionalsParams,
  GetReviewsByActivityIdParams,
  GetSessionByIdParams,
  GetSlotsByActivityParams,
  GetStripeAccountStatus200,
  GetSubscriptionPlans200,
  GetSubscriptionStatus200,
  GetSuggestionsParams,
  GetTransactionHistory200,
  GetTransactionHistoryParams,
  GetUnreadCount200,
  GetUnreadCountParams,
  GetUserActivitiesParams,
  GetUserBookingsParams,
  GetUserBookingsResponse,
  GetUsersParams,
  GetVapidPublicKey200,
  GrantFreeSubscription200,
  GrantFreeSubscriptionBody,
  GroupId,
  HandleWebhook200,
  HandleWebhookBody,
  ImproveActivityDescription200,
  ImproveActivityDescriptionBody,
  ImproveProfessionalBio200,
  ImproveProfessionalBioBody,
  InitiatePaymentForCashBooking200,
  InitiatePaymentForCashBookingBody,
  ListCategoriesResponse,
  ListGroupsResponse,
  ListNotifications200,
  ListNotificationsParams,
  MarkAllAsRead200,
  MarkAllAsReadParams,
  MarkAsRead200,
  MarkAsReadParams,
  MarkAttendanceBody,
  MarkAttendanceResponse,
  OpenDisputeBody,
  OpenDisputeResponse,
  PauseSubscription200,
  PauseSubscriptionBody,
  PrivateUserDownloadUrlRequest,
  PrivateUserDownloadUrlResponse,
  PrivateUserUploadUrlRequest,
  ProfessionalActivityList,
  ProfessionalAdminProfile,
  ProfessionalBooking,
  ProfessionalBookingBaseResponse,
  ProfessionalPrivateProfile,
  ProfessionalPublicProfile,
  ProfessionalResponse,
  ProfessionalRevision,
  Professionals,
  ProfessionalsAdmin,
  RemoveProfilePictureResponse,
  RemoveTimeslotRecursively200,
  RemoveTimeslotRecursivelyBody,
  ResolveDisputeBody,
  ResolveDisputeResponse,
  RestoreSessionBody,
  ResumeSubscription200,
  ResumeSubscriptionBody,
  Review,
  Reviews,
  RevokeCalendarTokenOutput,
  RevokeGrant200,
  RevokeGrantBody,
  SavedAddress,
  SavedAddressId,
  SearchSuggestionsResponse,
  SendOtp200,
  SendOtpBody,
  SendQueryParams,
  SendQueryResponse,
  Session,
  SessionId,
  SessionResponse,
  Slot,
  StartPayment200,
  StartPaymentBody,
  SubscribePush200,
  SubscribePushBody,
  UnblockProfessionalBody,
  UnblockProfessionalResponse,
  UnblockUserBody,
  UnblockUserResponse,
  UnsubscribePush200,
  UnsubscribePushParams,
  UpdateActivityBody,
  UpdateBookingBody,
  UpdateGroupParams,
  UpdateGroupResponse,
  UpdateProfessionalBody,
  UpdateProfessionalBookingBody,
  UpdateReviewStatusParams,
  UpdateSavedAddressBody,
  UpdateSessionBody,
  UpdateSlotOccurrenceBody,
  UpdateUserBody,
  UploadUrlRequest,
  UploadUrlResponse,
  UpsertNotificationPreferences200,
  UpsertNotificationPreferencesBody,
  User,
  UserId,
  Users,
  VerifyOtp200,
  VerifyOtpBody
} from './models';

// ============================================================================
// URL Builder Functions (direct exports)
// ============================================================================

/**
 * Return current user info
 * @summary Get current user
 */
export const getGetSessionUrl = () => {
  return `/session`;
};

/**
 * Returns basic activity data for all users. Activity owners receive additional information including booking count.
 * @summary Get an activity by its ID
 */
export const getGetActivityByIdUrl = (id: ActivityId, params?: GetActivityByIdParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/activities/${id}?${stringifiedParams}` : `/activities/${id}`;
};

/**
 * Update an existing activity
 * @summary Update an existing activity
 */
export const getUpdateActivityUrl = (id: ActivityId) => {
  return `/activities/${id}`;
};

/**
 * Remove an activity by its ID
 * @summary Remove an activity by its ID
 */
export const getRemoveActivityUrl = (id: ActivityId) => {
  return `/activities/${id}`;
};

/**
 * Get activities with pagination and advanced filtering
 * @summary Get activities with pagination and advanced filtering
 */
export const getGetActivitiesUrl = (params?: GetActivitiesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/activities?${stringifiedParams}` : `/activities`;
};

/**
 * Create a new activity
 * @summary Create a new activity
 */
export const getCreateActivityUrl = () => {
  return `/activities`;
};

/**
 * Get all activities for admin (includes all activities regardless of session status)
 * @summary Get all activities for admin (includes all activities regardless of session status)
 */
export const getGetActivitiesAdminUrl = (params?: GetActivitiesAdminParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/activities?${stringifiedParams}` : `/admin/activities`;
};

/**
 * Returns a list of featured activities with optional location-based filtering
 * @summary Get featured activities for the home page
 */
export const getGetActivitiesFeaturedUrl = (params?: GetActivitiesFeaturedParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/activities/featured?${stringifiedParams}` : `/activities/featured`;
};

/**
 * Improve an activity description using AI
 * @summary Improve an activity description using AI
 */
export const getImproveActivityDescriptionUrl = () => {
  return `/activities/description/improve`;
};

/**
 * Get the last time this activity's static-rendered page was invalidated. Owner/admin only; returns null for non-owners.
 * @summary Get the last time this activity's static-rendered page was invalidated. Owner/admin only; returns null for non-owners.
 */
export const getGetActivityCacheInfoUrl = (activityId: ActivityId) => {
  return `/activities/${activityId}/cache-info`;
};

/**
 * Get revision history for an activity
 * @summary Get revision history for an activity
 */
export const getGetActivityRevisionsUrl = (activityId: ActivityId) => {
  return `/activities/${activityId}/revisions`;
};

/**
 * Approve a pending activity revision, merging it into the live activity
 * @summary Approve a pending activity revision, merging it into the live activity
 */
export const getApproveActivityRevisionUrl = (activityId: ActivityId) => {
  return `/activities/${activityId}/revisions/approve`;
};

/**
 * Decline a pending activity revision with a reason
 * @summary Decline a pending activity revision with a reason
 */
export const getDeclineActivityRevisionUrl = (activityId: ActivityId) => {
  return `/activities/${activityId}/revisions/decline`;
};

/**
 * Get a pre-signed URL for asset upload
 * @summary Get a pre-signed URL for asset upload
 */
export const getGetAssetUploadUrlUrl = () => {
  return `/assets/upload-url`;
};

/**
 * Get a pre-signed URL for asset upload to private bucket
 * @summary Get a pre-signed URL for asset upload to private bucket
 */
export const getGetPrivateAssetUploadUrlUrl = () => {
  return `/assets/private/upload-url`;
};

/**
 * Get a pre-signed URL for authenticated user asset upload to private bucket
 * @summary Get a pre-signed URL for authenticated user asset upload to private bucket
 */
export const getGetPrivateUserAssetUploadUrlUrl = () => {
  return `/assets/private/user/upload-url`;
};

/**
 * Get a pre-signed URL to download an asset from the private user bucket (admin only)
 * @summary Get a pre-signed URL to download an asset from the private user bucket (admin only)
 */
export const getGetPrivateUserAssetDownloadUrlUrl = () => {
  return `/assets/private/user/download-url`;
};

/**
 * Deletes multiple private assets from storage based on their keys.
 * @summary Deletes multiple private assets from storage based on their keys.
 */
export const getDeletePrivateAssetsUrl = () => {
  return `/assets/private/delete`;
};

/**
 * Deletes multiple assets from storage based on their keys.
 * @summary Deletes multiple assets from storage based on their keys.
 */
export const getDeleteAssetsUrl = () => {
  return `/assets/delete`;
};

/**
 * List audit events with optional filters (admin only).
 * @summary List audit events with optional filters (admin only).
 */
export const getGetAuditEventsUrl = (params?: GetAuditEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/audit-events?${stringifiedParams}` : `/admin/audit-events`;
};

/**
 * Retrieves available time slots for given sessions for the next 6 months. Returns data grouped by month (YYYY-MM) then by day.
 * @summary Get available time slots for sessions
 */
export const getGetAvailableSlotsUrl = () => {
  return `/bookings/available-slots`;
};

/**
 * Create a new booking
 * @summary Create a new booking
 */
export const getCreateBookingUrl = () => {
  return `/bookings`;
};

/**
 * Get user bookings
 * @summary Get user bookings
 */
export const getGetUserBookingsUrl = (params?: GetUserBookingsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/bookings?${stringifiedParams}` : `/bookings`;
};

/**
 * Get booking by ID
 * @summary Get booking by ID
 */
export const getGetBookingByIdUrl = (id: string, params?: GetBookingByIdParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/bookings/${id}?${stringifiedParams}` : `/bookings/${id}`;
};

/**
 * Update a booking
 * @summary Update a booking
 */
export const getUpdateBookingUrl = (id: string) => {
  return `/bookings/${id}`;
};

/**
 * Cancel a booking
 * @summary Cancel a booking
 */
export const getDeleteBookingUrl = (id: string, params?: DeleteBookingParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/bookings/${id}?${stringifiedParams}` : `/bookings/${id}`;
};

/**
 * Get professional bookings with date range filtering
 * @summary Get professional bookings with date range filtering
 */
export const getGetProfessionalBookingsUrl = (params?: GetProfessionalBookingsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/professional-bookings?${stringifiedParams}` : `/professional-bookings`;
};

/**
 * Create a new professional booking for a client
 * @summary Create a new professional booking for a client
 */
export const getCreateProfessionalBookingUrl = () => {
  return `/professional-bookings`;
};

/**
 * Update a professional booking
 * @summary Update a professional booking
 */
export const getUpdateProfessionalBookingUrl = (id: string) => {
  return `/professional-bookings/${id}`;
};

/**
 * Cancel a professional booking
 * @summary Cancel a professional booking
 */
export const getDeleteProfessionalBookingUrl = (id: string, params?: DeleteProfessionalBookingParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/professional-bookings/${id}?${stringifiedParams}`
    : `/professional-bookings/${id}`;
};

/**
 * Open a dispute for a booking (within 48h after session end)
 * @summary Open a dispute for a booking (within 48h after session end)
 */
export const getOpenDisputeUrl = (id: string) => {
  return `/bookings/${id}/dispute`;
};

/**
 * Resolve a dispute (admin can accept/reject, professional can only accept)
 * @summary Resolve a dispute (admin can accept/reject, professional can only accept)
 */
export const getResolveDisputeUrl = (id: string) => {
  return `/bookings/${id}/dispute/resolve`;
};

/**
 * Initiate online payment for a cash booking (Pay Now feature)
 * @summary Initiate online payment for a cash booking (Pay Now feature)
 */
export const getInitiatePaymentForCashBookingUrl = (id: string) => {
  return `/bookings/${id}/initiate-payment`;
};

/**
 * Mark attendance for a booking (professional only)
 * @summary Mark attendance for a booking (professional only)
 */
export const getMarkAttendanceUrl = (id: string) => {
  return `/bookings/${id}/attendance`;
};

/**
 * Confirm a pending booking (cash or free)
 * @summary Confirm a pending booking (cash or free)
 */
export const getConfirmBookingUrl = (id: string) => {
  return `/bookings/${id}/confirm`;
};

/**
 * Returns existing valid calendar sync token if available, otherwise generates a new one.
 * @summary Get or generate calendar sync token
 */
export const getGenerateTokenUrl = () => {
  return `/calendar/token`;
};

/**
 * Revokes the current calendar sync token for the authenticated user
 * @summary Revoke calendar sync token
 */
export const getRevokeTokenUrl = () => {
  return `/calendar/token`;
};

/**
 * Returns ICS calendar feed for bookings and available slots (professionals only)
 * @summary Get calendar feed
 */
export const getGetCalendarFeedUrl = (params: GetCalendarFeedParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/calendar/feed.ics?${stringifiedParams}` : `/calendar/feed.ics`;
};

/**
 * List all available categories
 * @summary List all available categories
 */
export const getGetCategoriesUrl = () => {
  return `/categories`;
};

/**
 * Create a new category
 * @summary Create a new category
 */
export const getCreateCategoryUrl = () => {
  return `/categories`;
};

/**
 * Delete a category
 * @summary Delete a category
 */
export const getDeleteCategoryUrl = (id: CategoryId) => {
  return `/categories/${id}`;
};

/**
 * Returns aggregated statistics for the admin dashboard. Requires admin privileges.
 * @summary Get admin dashboard statistics including user counts, activities, and recent events
 */
export const getGetAdminDashboardStatsUrl = () => {
  return `/admin/dashboard/stats`;
};

/**
 * Get professional dashboard overview: wow-row stats, up-next booking, today/this-week schedule
 * @summary Get professional dashboard overview: wow-row stats, up-next booking, today/this-week schedule
 */
export const getGetDashboardOverviewUrl = (params?: GetDashboardOverviewParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/dashboard/overview?${stringifiedParams}` : `/dashboard/overview`;
};

/**
 * Get professional cashflow per day for a given month (cash + online + future bookings)
 * @summary Get professional cashflow per day for a given month (cash + online + future bookings)
 */
export const getGetDashboardCashflowUrl = (params: GetDashboardCashflowParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/dashboard/cashflow?${stringifiedParams}` : `/dashboard/cashflow`;
};

/**
 * Get professional booking counts per day for a given month (new / completed / cancelled)
 * @summary Get professional booking counts per day for a given month (new / completed / cancelled)
 */
export const getGetDashboardBookingsChartUrl = (params: GetDashboardBookingsChartParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/dashboard/bookings-chart?${stringifiedParams}` : `/dashboard/bookings-chart`;
};

/**
 * Get professional mentee summary: top loyal mentees and new mentees over 3m and 6m windows
 * @summary Get professional mentee summary: top loyal mentees and new mentees over 3m and 6m windows
 */
export const getGetDashboardMenteesUrl = () => {
  return `/dashboard/mentees`;
};

/**
 * Get professional dashboard bookings chart data with new and cancelled bookings
 * @summary Get professional dashboard bookings chart data with new and cancelled bookings
 */
export const getGetProfessionalDashboardBookingsUrl = (params?: GetProfessionalDashboardBookingsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/dashboard/bookings?${stringifiedParams}` : `/dashboard/bookings`;
};

/**
 * Get professional dashboard earnings chart data grouped by date and transaction type
 * @summary Get professional dashboard earnings chart data grouped by date and transaction type
 */
export const getGetProfessionalDashboardEarningsUrl = (params?: GetProfessionalDashboardEarningsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/dashboard/earnings?${stringifiedParams}` : `/dashboard/earnings`;
};

/**
 * Get professional dashboard metrics summary with aggregated counts
 * @summary Get professional dashboard metrics summary with aggregated counts
 */
export const getGetProfessionalDashboardMetricsUrl = (params?: GetProfessionalDashboardMetricsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/dashboard/metrics?${stringifiedParams}` : `/dashboard/metrics`;
};

/**
 * Get list of booking disputes (admin only)
 * @summary Get list of booking disputes (admin only)
 */
export const getGetAdminDisputesUrl = (params?: GetAdminDisputesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/disputes?${stringifiedParams}` : `/admin/disputes`;
};

/**
 * Block a professional (admin only)
 * @summary Block a professional (admin only)
 */
export const getBlockProfessionalUrl = (professionalId: string) => {
  return `/admin/professionals/${professionalId}/block`;
};

/**
 * Unblock a professional (admin only)
 * @summary Unblock a professional (admin only)
 */
export const getUnblockProfessionalUrl = (professionalId: string) => {
  return `/admin/professionals/${professionalId}/unblock`;
};

/**
 * List all groups (admin only)
 * @summary List all groups (admin only)
 */
export const getListGroupsUrl = () => {
  return `/admin/groups`;
};

/**
 * Create a new group (admin only)
 * @summary Create a new group (admin only)
 */
export const getCreateGroupUrl = () => {
  return `/admin/groups`;
};

/**
 * Rename or edit a group (admin only)
 * @summary Rename or edit a group (admin only)
 */
export const getUpdateGroupUrl = (id: GroupId, params?: UpdateGroupParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/groups/${id}?${stringifiedParams}` : `/admin/groups/${id}`;
};

/**
 * Delete a group (admin only). Refuses if any user/professional/activity references it.
 * @summary Delete a group (admin only). Refuses if any user/professional/activity references it.
 */
export const getDeleteGroupUrl = (id: GroupId) => {
  return `/admin/groups/${id}`;
};

/**
 * Replace a user's group memberships (admin only)
 * @summary Replace a user's group memberships (admin only)
 */
export const getAssignUserGroupsUrl = (id: UserId) => {
  return `/admin/users/${id}/groups`;
};

/**
 * Replace an activity audience-scope set (admin only)
 * @summary Replace an activity audience-scope set (admin only)
 */
export const getAssignActivityScopesUrl = (id: ActivityId) => {
  return `/admin/activities/${id}/scopes`;
};

/**
 * List notifications for a user with pagination
 * @summary List notifications for a user with pagination
 */
export const getListNotificationsUrl = (params?: ListNotificationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/notifications?${stringifiedParams}` : `/notifications`;
};

/**
 * Get count of unread notifications for a user
 * @summary Get count of unread notifications for a user
 */
export const getGetUnreadCountUrl = (params?: GetUnreadCountParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/notifications/unread-count?${stringifiedParams}`
    : `/notifications/unread-count`;
};

/**
 * Mark a notification as read
 * @summary Mark a notification as read
 */
export const getMarkAsReadUrl = (id: string, params?: MarkAsReadParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/notifications/${id}/read?${stringifiedParams}` : `/notifications/${id}/read`;
};

/**
 * Mark all notifications as read for a user
 * @summary Mark all notifications as read for a user
 */
export const getMarkAllAsReadUrl = (params?: MarkAllAsReadParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/notifications/read-all?${stringifiedParams}` : `/notifications/read-all`;
};

/**
 * Soft delete a notification
 * @summary Soft delete a notification
 */
export const getDeleteNotificationUrl = (id: string, params?: DeleteNotificationParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/notifications/${id}?${stringifiedParams}` : `/notifications/${id}`;
};

/**
 * Get notification preferences for a user
 * @summary Get notification preferences for a user
 */
export const getGetNotificationPreferencesUrl = (params?: GetNotificationPreferencesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/notifications/preferences?${stringifiedParams}`
    : `/notifications/preferences`;
};

/**
 * Create or update notification preferences for a user
 * @summary Create or update notification preferences for a user
 */
export const getUpsertNotificationPreferencesUrl = () => {
  return `/notifications/preferences`;
};

/**
 * Return the VAPID public key the browser needs to subscribe to web push
 * @summary Return the VAPID public key the browser needs to subscribe to web push
 */
export const getGetVapidPublicKeyUrl = () => {
  return `/push/vapid-public-key`;
};

/**
 * Register a Web Push subscription for the current user's device
 * @summary Register a Web Push subscription for the current user's device
 */
export const getSubscribePushUrl = () => {
  return `/push/subscribe`;
};

/**
 * Remove a Web Push subscription for the current user's device
 * @summary Remove a Web Push subscription for the current user's device
 */
export const getUnsubscribePushUrl = (params: UnsubscribePushParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/push/subscribe?${stringifiedParams}` : `/push/subscribe`;
};

/**
 * Send OTP verification code to a phone number via SMS
 * @summary Send OTP verification code to a phone number via SMS
 */
export const getSendOtpUrl = () => {
  return `/otp/send`;
};

/**
 * Verify OTP code for a phone number
 * @summary Verify OTP code for a phone number
 */
export const getVerifyOtpUrl = () => {
  return `/otp/verify`;
};

/**
 * Get a professional's public profile by ID
 * @summary Get a professional's public profile by ID
 */
export const getGetProfessionalPublicProfileUrl = (id: UserId) => {
  return `/professionals/${id}`;
};

/**
 * Allows updating fields like bio, profile picture, email, and social links. Requires admin privileges or the user to be updating their own profile.
 * @summary Updates specific fields of an existing professional profile.
 */
export const getUpdateProfessionalUrl = (id: UserId) => {
  return `/professionals/${id}`;
};

/**
 * Returns the professional profile including moderation status and revision history. Accessible to the owner of the profile or an administrator.
 * @summary Get a professional's private profile (owner or admin)
 */
export const getGetProfessionalPrivateProfileUrl = (id: UserId) => {
  return `/professionals/${id}/private-profile`;
};

/**
 * Returns the complete professional and user information, including sensitive data like private email, admin flags and stripe state. Superset of the owner profile. Only accessible to admin users.
 * @summary Get a professional's admin profile with sensitive data (Admin only)
 */
export const getGetProfessionalAdminProfileUrl = (id: UserId) => {
  return `/professionals/${id}/admin-profile`;
};

/**
 * Returns a paginated list of professionals with full admin profile data including sensitive user information. Only accessible to admin users. This is a batch alternative to calling getProfessionalAdminProfile for each professional individually.
 * @summary List professionals with admin-level details (Admin only)
 */
export const getGetProfessionalsAdminUrl = (params?: GetProfessionalsAdminParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/professionals?${stringifiedParams}` : `/admin/professionals`;
};

/**
 * Get a list of professionals with optional search query that matches against name or address fields.
 * @summary Search and list professionals
 */
export const getGetProfessionalsUrl = (params?: GetProfessionalsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/professionals?${stringifiedParams}` : `/professionals`;
};

/**
 * Create a new professional profile
 * @summary Create a new professional profile
 */
export const getCreateProfessionalUrl = () => {
  return `/professionals`;
};

/**
 * Get activities offered by a specific professional
 * @summary Get activities offered by a specific professional
 */
export const getGetProfessionalActivitiesUrl = (id: UserId, params?: GetProfessionalActivitiesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/professionals/${id}/activities?${stringifiedParams}`
    : `/professionals/${id}/activities`;
};

/**
 * Get the last time this professional's static-rendered page was invalidated. Owner/admin only; returns null for non-owners.
 * @summary Get the last time this professional's static-rendered page was invalidated. Owner/admin only; returns null for non-owners.
 */
export const getGetProfessionalCacheInfoUrl = (id: UserId) => {
  return `/professionals/${id}/cache-info`;
};

/**
 * Approve a pending professional revision, merging it into the live profile
 * @summary Approve a pending professional revision, merging it into the live profile
 */
export const getApproveProfessionalRevisionUrl = (professionalId: UserId) => {
  return `/professionals/${professionalId}/revisions/approve`;
};

/**
 * Decline a pending professional revision with a reason
 * @summary Decline a pending professional revision with a reason
 */
export const getDeclineProfessionalRevisionUrl = (professionalId: UserId) => {
  return `/professionals/${professionalId}/revisions/decline`;
};

/**
 * Improve a professional bio using AI
 * @summary Improve a professional bio using AI
 */
export const getImproveProfessionalBioUrl = () => {
  return `/professionals/bio/improve`;
};

/**
 * send new query by email
 * @summary send new query by email
 */
export const getSendQueryUrl = () => {
  return `/queries/send`;
};

/**
 * Get reviews for a specific activity
 * @summary Get reviews for a specific activity
 */
export const getGetReviewsByActivityIdUrl = (activityId: ActivityId, params?: GetReviewsByActivityIdParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/activities/${activityId}/reviews?${stringifiedParams}`
    : `/activities/${activityId}/reviews`;
};

/**
 * Create a review for an activity
 * @summary Create a review for an activity
 */
export const getCreateReviewUrl = (activityId: ActivityId) => {
  return `/activities/${activityId}/reviews`;
};

/**
 * Approve or reject a review (professional only)
 * @summary Approve or reject a review (professional only)
 */
export const getUpdateReviewStatusUrl = (reviewId: string, params: UpdateReviewStatusParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/reviews/${reviewId}/status?${stringifiedParams}`
    : `/reviews/${reviewId}/status`;
};

/**
 * Create a saved address for authenticated user
 * @summary Create a saved address for authenticated user
 */
export const getCreateSavedAddressUrl = () => {
  return `/saved-addresses`;
};

/**
 * Get all saved addresses for authenticated user
 * @summary Get all saved addresses for authenticated user
 */
export const getGetSavedAddressesUrl = () => {
  return `/saved-addresses`;
};

/**
 * Get a saved address by ID for authenticated user
 * @summary Get a saved address by ID for authenticated user
 */
export const getGetSavedAddressByIdUrl = (id: SavedAddressId) => {
  return `/saved-addresses/${id}`;
};

/**
 * Update a saved address for authenticated user
 * @summary Update a saved address for authenticated user
 */
export const getUpdateSavedAddressUrl = (id: SavedAddressId) => {
  return `/saved-addresses/${id}`;
};

/**
 * Delete a saved address for authenticated user
 * @summary Delete a saved address for authenticated user
 */
export const getDeleteSavedAddressUrl = (id: SavedAddressId) => {
  return `/saved-addresses/${id}`;
};

/**
 * Create a new session for an activity
 * @summary Create a new session for an activity
 */
export const getCreateSessionUrl = () => {
  return `/sessions`;
};

/**
 * Returns a session by its ID
 * @summary Get a session by its ID
 */
export const getGetSessionByIdUrl = (id: string, params?: GetSessionByIdParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sessions/${id}?${stringifiedParams}` : `/sessions/${id}`;
};

/**
 * Update an existing session
 * @summary Update an existing session
 */
export const getUpdateSessionUrl = (id: SessionId) => {
  return `/sessions/${id}`;
};

/**
 * Delete a session and its associated slots
 * @summary Delete a session and its associated slots
 */
export const getDeleteSessionUrl = (id: SessionId) => {
  return `/sessions/${id}`;
};

/**
 * Archive a session: hide it and stop new bookings while keeping existing bookings intact
 * @summary Archive a session: hide it and stop new bookings while keeping existing bookings intact
 */
export const getArchiveSessionUrl = (id: SessionId) => {
  return `/sessions/${id}/archive`;
};

/**
 * Restore an archived session back to active, re-opening its future availability
 * @summary Restore an archived session back to active, re-opening its future availability
 */
export const getRestoreSessionUrl = (id: SessionId) => {
  return `/sessions/${id}/restore`;
};

/**
 * Cancel a single slot occurrence for a specific date (creates or updates a CANCELLED slot)
 * @summary Cancel a single slot occurrence for a specific date (creates or updates a CANCELLED slot)
 */
export const getCancelSlotOccurrenceUrl = () => {
  return `/slots/cancel`;
};

/**
 * Get all persisted slots for an activity (overridden or cancelled slots)
 * @summary Get all persisted slots for an activity (overridden or cancelled slots)
 */
export const getGetSlotsByActivityUrl = (params: GetSlotsByActivityParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/slots/by-activity?${stringifiedParams}` : `/slots/by-activity`;
};

/**
 * Remove a timeslot from a session for all future dates. Past slots and slots with bookings are left unchanged. If no slots remain, the session is deleted.
 * @summary Remove a timeslot from a session for all future dates. Past slots and slots with bookings are left unchanged. If no slots remain, the session is deleted.
 */
export const getRemoveTimeslotRecursivelyUrl = () => {
  return `/slots/remove-recursive`;
};

/**
 * Update a single slot occurrence for a specific date (creates or updates an overridden slot)
 * @summary Update a single slot occurrence for a specific date (creates or updates an overridden slot)
 */
export const getUpdateSlotOccurrenceUrl = () => {
  return `/slots/update-occurrence`;
};

/**
 * Create a Stripe Connect account for a professional
 * @summary Create a Stripe Connect account for a professional
 */
export const getCreateStripeAccountUrl = () => {
  return `/stripe/account`;
};

/**
 * Create an account session for Stripe embedded onboarding
 * @summary Create an account session for Stripe embedded onboarding
 */
export const getCreateAccountSessionUrl = () => {
  return `/stripe/account-session`;
};

/**
 * Create an Account Link for Stripe hosted onboarding
 * @summary Create an Account Link for Stripe hosted onboarding
 */
export const getCreateAccountLinkUrl = () => {
  return `/stripe/account-link`;
};

/**
 * Get Stripe account onboarding status for a professional
 * @summary Get Stripe account onboarding status for a professional
 */
export const getGetStripeAccountStatusUrl = (professionalId: string) => {
  return `/stripe/account-status/${professionalId}`;
};

/**
 * Get payment dashboard data for a professional including on-hold, disputed, and payout-ready bookings
 * @summary Get payment dashboard data for a professional including on-hold, disputed, and payout-ready bookings
 */
export const getGetProfessionalPaymentsDashboardUrl = (professionalId: string) => {
  return `/stripe/payments-dashboard/${professionalId}`;
};

/**
 * Create a login link to the Stripe Express Dashboard
 * @summary Create a login link to the Stripe Express Dashboard
 */
export const getCreateDashboardLoginLinkUrl = () => {
  return `/stripe/dashboard-login-link`;
};

/**
 * Create a PaymentIntent for a booking
 * @summary Create a PaymentIntent for a booking
 */
export const getCreatePaymentIntentUrl = () => {
  return `/stripe/payment-intent`;
};

/**
 * Lock a booking for payment processing (PENDING_PAYMENT → PROCESSING_PAYMENT)
 * @summary Lock a booking for payment processing (PENDING_PAYMENT → PROCESSING_PAYMENT)
 */
export const getStartPaymentUrl = () => {
  return `/stripe/start-payment`;
};

/**
 * Receives and processes Stripe webhook events for payment status updates. Uses Stripe signature verification instead of JWT authentication.
 * @summary Handle Stripe webhook events
 */
export const getHandleWebhookUrl = () => {
  return `/stripe/webhook`;
};

/**
 * List all available subscription plans
 * @summary List all available subscription plans
 */
export const getGetSubscriptionPlansUrl = () => {
  return `/subscriptions/plans`;
};

/**
 * Get current subscription status, usage, and access for a professional
 * @summary Get current subscription status, usage, and access for a professional
 */
export const getGetSubscriptionStatusUrl = (professionalId: string) => {
  return `/subscriptions/status/${professionalId}`;
};

/**
 * Get combined subscription and booking transaction history for a professional
 * @summary Get combined subscription and booking transaction history for a professional
 */
export const getGetTransactionHistoryUrl = (professionalId: string, params?: GetTransactionHistoryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/subscriptions/transactions/${professionalId}?${stringifiedParams}`
    : `/subscriptions/transactions/${professionalId}`;
};

/**
 * Subscribe a professional to a plan
 * @summary Subscribe a professional to a plan
 */
export const getCreateSubscriptionUrl = () => {
  return `/subscriptions/subscribe`;
};

/**
 * Cancel a subscription at the end of the current billing period
 * @summary Cancel a subscription at the end of the current billing period
 */
export const getCancelSubscriptionUrl = () => {
  return `/subscriptions/cancel`;
};

/**
 * Pause a subscription (billing paused until resumed)
 * @summary Pause a subscription (billing paused until resumed)
 */
export const getPauseSubscriptionUrl = () => {
  return `/subscriptions/pause`;
};

/**
 * Resume a paused subscription
 * @summary Resume a paused subscription
 */
export const getResumeSubscriptionUrl = () => {
  return `/subscriptions/resume`;
};

/**
 * Upgrade or downgrade subscription plan
 * @summary Upgrade or downgrade subscription plan
 */
export const getChangeSubscriptionPlanUrl = () => {
  return `/subscriptions/change-plan`;
};

/**
 * Admin grants a professional free subscription for a number of months
 * @summary Admin grants a professional free subscription for a number of months
 */
export const getGrantFreeSubscriptionUrl = () => {
  return `/subscriptions/grant`;
};

/**
 * Admin revokes a free subscription grant
 * @summary Admin revokes a free subscription grant
 */
export const getRevokeGrantUrl = () => {
  return `/subscriptions/revoke-grant`;
};

/**
 * Create a Stripe Customer Portal session for managing payment methods and billing
 * @summary Create a Stripe Customer Portal session for managing payment methods and billing
 */
export const getCreateBillingPortalSessionUrl = () => {
  return `/subscriptions/billing-portal`;
};

/**
 * Create a Stripe SetupIntent for updating the payment method on a subscription
 * @summary Create a Stripe SetupIntent for updating the payment method on a subscription
 */
export const getCreateSetupIntentUrl = () => {
  return `/subscriptions/setup-intent`;
};

/**
 * Get keyword search suggestions for the search bar
 * @summary Get keyword search suggestions for the search bar
 */
export const getGetSuggestionsUrl = (params: GetSuggestionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/suggestions?${stringifiedParams}` : `/suggestions`;
};

/**
 * Get user by user Id
 * @summary Get user by user Id
 */
export const getGetUserByIdUrl = (id: UserId) => {
  return `/users/${id}`;
};

/**
 * Update user information
 * @summary Update user information
 */
export const getUpdateUserUrl = (id: UserId) => {
  return `/users/${id}`;
};

/**
 * Get all activities for a user
 * @summary Get all activities for a user
 */
export const getGetUserActivitiesUrl = (userId: UserId, params?: GetUserActivitiesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/users/${userId}/activities?${stringifiedParams}`
    : `/users/${userId}/activities`;
};

/**
 * List all users
 * @summary List all users
 */
export const getGetUsersUrl = (params?: GetUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/users?${stringifiedParams}` : `/users`;
};

/**
 * Create a user
 * @summary Create a user
 */
export const getCreateUserUrl = () => {
  return `/users`;
};

/**
 * Remove the current user's profile picture
 * @summary Remove the current user's profile picture
 */
export const getRemoveProfilePictureUrl = () => {
  return `/users/profile-picture`;
};

/**
 * Block a user (admin only)
 * @summary Block a user (admin only)
 */
export const getBlockUserUrl = (userId: string) => {
  return `/admin/users/${userId}/block`;
};

/**
 * Unblock a user (admin only)
 * @summary Unblock a user (admin only)
 */
export const getUnblockUserUrl = (userId: string) => {
  return `/admin/users/${userId}/unblock`;
};

// ============================================================================
// API Client Interface
// ============================================================================

/**
 * Interface for the API client returned by createApiClient.
 * All methods are bound to the custom fetch implementation provided.
 */
export interface ApiClient {
  getSession: (options?: RequestInit) => Promise<SessionResponse>;

  getActivityById: (id: ActivityId,
  params?: GetActivityByIdParams,
  options?: RequestInit) => Promise<ActivityDetail>;

  updateActivity: (id: ActivityId,
  updateActivityBody: UpdateActivityBody,
  options?: RequestInit) => Promise<Activity>;

  removeActivity: (id: ActivityId, options?: RequestInit) => Promise<null>;

  getActivities: (params?: GetActivitiesParams,
  options?: RequestInit) => Promise<ActivitySearchResults>;

  createActivity: (createActivityBody: CreateActivityBody,
  options?: RequestInit) => Promise<Activity>;

  getActivitiesAdmin: (params?: GetActivitiesAdminParams,
  options?: RequestInit) => Promise<AdminActivitySearchResults>;

  getActivitiesFeatured: (params?: GetActivitiesFeaturedParams,
  options?: RequestInit) => Promise<ActivityFeaturedResults>;

  improveActivityDescription: (improveActivityDescriptionBody: ImproveActivityDescriptionBody,
  options?: RequestInit) => Promise<ImproveActivityDescription200>;

  getActivityCacheInfo: (activityId: ActivityId,
  options?: RequestInit) => Promise<GetActivityCacheInfo200>;

  getActivityRevisions: (activityId: ActivityId,
  options?: RequestInit) => Promise<GetActivityRevisions200Item[]>;

  approveActivityRevision: (activityId: ActivityId,
  approveActivityRevisionBody: ApproveActivityRevisionBody,
  options?: RequestInit) => Promise<Activity>;

  declineActivityRevision: (activityId: ActivityId,
  declineActivityRevisionBody: DeclineActivityRevisionBody,
  options?: RequestInit) => Promise<DeclineActivityRevision200>;

  getAssetUploadUrl: (uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit) => Promise<UploadUrlResponse>;

  getPrivateAssetUploadUrl: (getPrivateAssetUploadUrlBody: GetPrivateAssetUploadUrlBody,
  options?: RequestInit) => Promise<UploadUrlResponse>;

  getPrivateUserAssetUploadUrl: (privateUserUploadUrlRequest: PrivateUserUploadUrlRequest,
  options?: RequestInit) => Promise<GetPrivateUserAssetUploadUrl200>;

  getPrivateUserAssetDownloadUrl: (privateUserDownloadUrlRequest: PrivateUserDownloadUrlRequest,
  options?: RequestInit) => Promise<PrivateUserDownloadUrlResponse>;

  deletePrivateAssets: (deletePrivateAssetsBody: DeletePrivateAssetsBody,
  options?: RequestInit) => Promise<null>;

  deleteAssets: (deleteAssetsBody: DeleteAssetsBody, options?: RequestInit) => Promise<null>;

  getAuditEvents: (params?: GetAuditEventsParams,
  options?: RequestInit) => Promise<GetAuditEventsResponse>;

  getAvailableSlots: (getAvailableSlotsInput: GetAvailableSlotsInput,
  options?: RequestInit) => Promise<GetAvailableSlotsOutput>;

  createBooking: (createBookingBody: CreateBookingBody,
  options?: RequestInit) => Promise<BookingResponse>;

  getUserBookings: (params?: GetUserBookingsParams,
  options?: RequestInit) => Promise<GetUserBookingsResponse>;

  getBookingById: (id: string,
  params?: GetBookingByIdParams,
  options?: RequestInit) => Promise<GetBookingByIdResponse>;

  updateBooking: (id: string,
  updateBookingBody: UpdateBookingBody,
  options?: RequestInit) => Promise<BookingResponse>;

  deleteBooking: (id: string,
  params?: DeleteBookingParams,
  options?: RequestInit) => Promise<DeleteBookingResponse>;

  getProfessionalBookings: (params?: GetProfessionalBookingsParams,
  options?: RequestInit) => Promise<GetProfessionalBookingsResponse>;

  createProfessionalBooking: (professionalBooking: ProfessionalBooking,
  options?: RequestInit) => Promise<ProfessionalBookingBaseResponse>;

  updateProfessionalBooking: (id: string,
  updateProfessionalBookingBody: UpdateProfessionalBookingBody,
  options?: RequestInit) => Promise<ProfessionalBookingBaseResponse>;

  deleteProfessionalBooking: (id: string,
  params?: DeleteProfessionalBookingParams,
  options?: RequestInit) => Promise<DeleteBookingResponse>;

  openDispute: (id: string,
  openDisputeBody: OpenDisputeBody,
  options?: RequestInit) => Promise<OpenDisputeResponse>;

  resolveDispute: (id: string,
  resolveDisputeBody: ResolveDisputeBody,
  options?: RequestInit) => Promise<ResolveDisputeResponse>;

  initiatePaymentForCashBooking: (id: string,
  initiatePaymentForCashBookingBody: InitiatePaymentForCashBookingBody,
  options?: RequestInit) => Promise<InitiatePaymentForCashBooking200>;

  markAttendance: (id: string,
  markAttendanceBody: MarkAttendanceBody,
  options?: RequestInit) => Promise<MarkAttendanceResponse>;

  confirmBooking: (id: string,
  confirmBookingBody: ConfirmBookingBody,
  options?: RequestInit) => Promise<BookingResponse>;

  generateToken: (options?: RequestInit) => Promise<GenerateCalendarTokenOutput>;

  revokeToken: (options?: RequestInit) => Promise<RevokeCalendarTokenOutput>;

  getCalendarFeed: (params: GetCalendarFeedParams,
  options?: RequestInit) => Promise<GetCalendarFeedOutput>;

  getCategories: (options?: RequestInit) => Promise<ListCategoriesResponse>;

  createCategory: (createCategoryRequest: CreateCategoryRequest,
  options?: RequestInit) => Promise<CreateCategoryResponse>;

  deleteCategory: (id: CategoryId, options?: RequestInit) => Promise<DeleteCategoryResponse>;

  getAdminDashboardStats: (options?: RequestInit) => Promise<GetAdminDashboardStats200>;

  getDashboardOverview: (params?: GetDashboardOverviewParams,
  options?: RequestInit) => Promise<DashboardOverviewResponse>;

  getDashboardCashflow: (params: GetDashboardCashflowParams,
  options?: RequestInit) => Promise<DashboardCashflowResponse>;

  getDashboardBookingsChart: (params: GetDashboardBookingsChartParams,
  options?: RequestInit) => Promise<DashboardBookingsChartResponse>;

  getDashboardMentees: (options?: RequestInit) => Promise<DashboardMenteesResponse>;

  getProfessionalDashboardBookings: (params?: GetProfessionalDashboardBookingsParams,
  options?: RequestInit) => Promise<DashboardBookingsResponse>;

  getProfessionalDashboardEarnings: (params?: GetProfessionalDashboardEarningsParams,
  options?: RequestInit) => Promise<DashboardEarningsResponse>;

  getProfessionalDashboardMetrics: (params?: GetProfessionalDashboardMetricsParams,
  options?: RequestInit) => Promise<DashboardMetricsResponse>;

  getAdminDisputes: (params?: GetAdminDisputesParams,
  options?: RequestInit) => Promise<GetAdminDisputesResponse>;

  blockProfessional: (professionalId: string,
  blockProfessionalBody: BlockProfessionalBody,
  options?: RequestInit) => Promise<BlockProfessionalResponse>;

  unblockProfessional: (professionalId: string,
  unblockProfessionalBody: UnblockProfessionalBody,
  options?: RequestInit) => Promise<UnblockProfessionalResponse>;

  listGroups: (options?: RequestInit) => Promise<ListGroupsResponse>;

  createGroup: (createGroupRequest: CreateGroupRequest,
  options?: RequestInit) => Promise<CreateGroupResponse>;

  updateGroup: (id: GroupId,
  params?: UpdateGroupParams,
  options?: RequestInit) => Promise<UpdateGroupResponse>;

  deleteGroup: (id: GroupId, options?: RequestInit) => Promise<DeleteGroupResponse>;

  assignUserGroups: (id: UserId,
  assignUserGroupsBody: AssignUserGroupsBody,
  options?: RequestInit) => Promise<AssignUserGroupsResponse>;

  assignActivityScopes: (id: ActivityId,
  assignActivityScopesBody: AssignActivityScopesBody,
  options?: RequestInit) => Promise<AssignActivityScopesResponse>;

  listNotifications: (params?: ListNotificationsParams,
  options?: RequestInit) => Promise<ListNotifications200>;

  getUnreadCount: (params?: GetUnreadCountParams,
  options?: RequestInit) => Promise<GetUnreadCount200>;

  markAsRead: (id: string,
  params?: MarkAsReadParams,
  options?: RequestInit) => Promise<MarkAsRead200>;

  markAllAsRead: (params?: MarkAllAsReadParams, options?: RequestInit) => Promise<MarkAllAsRead200>;

  deleteNotification: (id: string,
  params?: DeleteNotificationParams,
  options?: RequestInit) => Promise<DeleteNotification200>;

  getNotificationPreferences: (params?: GetNotificationPreferencesParams,
  options?: RequestInit) => Promise<GetNotificationPreferences200>;

  upsertNotificationPreferences: (upsertNotificationPreferencesBody: UpsertNotificationPreferencesBody,
  options?: RequestInit) => Promise<UpsertNotificationPreferences200>;

  getVapidPublicKey: (options?: RequestInit) => Promise<GetVapidPublicKey200>;

  subscribePush: (subscribePushBody: SubscribePushBody,
  options?: RequestInit) => Promise<SubscribePush200>;

  unsubscribePush: (params: UnsubscribePushParams,
  options?: RequestInit) => Promise<UnsubscribePush200>;

  sendOtp: (sendOtpBody: SendOtpBody, options?: RequestInit) => Promise<SendOtp200>;

  verifyOtp: (verifyOtpBody: VerifyOtpBody, options?: RequestInit) => Promise<VerifyOtp200>;

  getProfessionalPublicProfile: (id: UserId,
  options?: RequestInit) => Promise<ProfessionalPublicProfile>;

  updateProfessional: (id: UserId,
  updateProfessionalBody: UpdateProfessionalBody,
  options?: RequestInit) => Promise<ProfessionalResponse>;

  getProfessionalPrivateProfile: (id: UserId,
  options?: RequestInit) => Promise<ProfessionalPrivateProfile>;

  getProfessionalAdminProfile: (id: UserId,
  options?: RequestInit) => Promise<ProfessionalAdminProfile>;

  getProfessionalsAdmin: (params?: GetProfessionalsAdminParams,
  options?: RequestInit) => Promise<ProfessionalsAdmin>;

  getProfessionals: (params?: GetProfessionalsParams,
  options?: RequestInit) => Promise<Professionals>;

  createProfessional: (createProfessionalBody: CreateProfessionalBody,
  options?: RequestInit) => Promise<ProfessionalResponse>;

  getProfessionalActivities: (id: UserId,
  params?: GetProfessionalActivitiesParams,
  options?: RequestInit) => Promise<ProfessionalActivityList>;

  getProfessionalCacheInfo: (id: UserId,
  options?: RequestInit) => Promise<GetProfessionalCacheInfo200>;

  approveProfessionalRevision: (professionalId: UserId,
  approveProfessionalRevisionBody: ApproveProfessionalRevisionBody,
  options?: RequestInit) => Promise<ProfessionalResponse>;

  declineProfessionalRevision: (professionalId: UserId,
  declineProfessionalRevisionBody: DeclineProfessionalRevisionBody,
  options?: RequestInit) => Promise<ProfessionalRevision>;

  improveProfessionalBio: (improveProfessionalBioBody: ImproveProfessionalBioBody,
  options?: RequestInit) => Promise<ImproveProfessionalBio200>;

  sendQuery: (sendQueryParams: SendQueryParams,
  options?: RequestInit) => Promise<SendQueryResponse>;

  getReviewsByActivityId: (activityId: ActivityId,
  params?: GetReviewsByActivityIdParams,
  options?: RequestInit) => Promise<Reviews>;

  createReview: (activityId: ActivityId,
  createReviewBody: CreateReviewBody,
  options?: RequestInit) => Promise<Review>;

  updateReviewStatus: (reviewId: string,
  params: UpdateReviewStatusParams,
  options?: RequestInit) => Promise<Review>;

  createSavedAddress: (createSavedAddress: CreateSavedAddress,
  options?: RequestInit) => Promise<SavedAddress>;

  getSavedAddresses: (options?: RequestInit) => Promise<SavedAddress[]>;

  getSavedAddressById: (id: SavedAddressId, options?: RequestInit) => Promise<SavedAddress>;

  updateSavedAddress: (id: SavedAddressId,
  updateSavedAddressBody: UpdateSavedAddressBody,
  options?: RequestInit) => Promise<SavedAddress>;

  deleteSavedAddress: (id: SavedAddressId, options?: RequestInit) => Promise<DeleteSavedAddress200>;

  createSession: (createSessionBody: CreateSessionBody, options?: RequestInit) => Promise<Session>;

  getSessionById: (id: string,
  params?: GetSessionByIdParams,
  options?: RequestInit) => Promise<Session>;

  updateSession: (id: SessionId,
  updateSessionBody: UpdateSessionBody,
  options?: RequestInit) => Promise<Session>;

  deleteSession: (id: SessionId, options?: RequestInit) => Promise<DeleteSession200>;

  archiveSession: (id: SessionId,
  archiveSessionBody: ArchiveSessionBody,
  options?: RequestInit) => Promise<Session>;

  restoreSession: (id: SessionId,
  restoreSessionBody: RestoreSessionBody,
  options?: RequestInit) => Promise<Session>;

  cancelSlotOccurrence: (cancelSlotOccurrenceBody: CancelSlotOccurrenceBody,
  options?: RequestInit) => Promise<Slot>;

  getSlotsByActivity: (params: GetSlotsByActivityParams, options?: RequestInit) => Promise<Slot[]>;

  removeTimeslotRecursively: (removeTimeslotRecursivelyBody: RemoveTimeslotRecursivelyBody,
  options?: RequestInit) => Promise<RemoveTimeslotRecursively200>;

  updateSlotOccurrence: (updateSlotOccurrenceBody: UpdateSlotOccurrenceBody,
  options?: RequestInit) => Promise<Slot>;

  createStripeAccount: (createStripeAccountBody: CreateStripeAccountBody,
  options?: RequestInit) => Promise<CreateStripeAccount200>;

  createAccountSession: (createAccountSessionBody: CreateAccountSessionBody,
  options?: RequestInit) => Promise<CreateAccountSession200>;

  createAccountLink: (createAccountLinkBody: CreateAccountLinkBody,
  options?: RequestInit) => Promise<CreateAccountLink200>;

  getStripeAccountStatus: (professionalId: string,
  options?: RequestInit) => Promise<GetStripeAccountStatus200>;

  getProfessionalPaymentsDashboard: (professionalId: string,
  options?: RequestInit) => Promise<GetProfessionalPaymentsDashboard200>;

  createDashboardLoginLink: (createDashboardLoginLinkBody: CreateDashboardLoginLinkBody,
  options?: RequestInit) => Promise<CreateDashboardLoginLink200>;

  createPaymentIntent: (createPaymentIntentBody: CreatePaymentIntentBody,
  options?: RequestInit) => Promise<CreatePaymentIntent200>;

  startPayment: (startPaymentBody: StartPaymentBody,
  options?: RequestInit) => Promise<StartPayment200>;

  handleWebhook: (handleWebhookBody: HandleWebhookBody,
  options?: RequestInit) => Promise<HandleWebhook200>;

  getSubscriptionPlans: (options?: RequestInit) => Promise<GetSubscriptionPlans200>;

  getSubscriptionStatus: (professionalId: string,
  options?: RequestInit) => Promise<GetSubscriptionStatus200>;

  getTransactionHistory: (professionalId: string,
  params?: GetTransactionHistoryParams,
  options?: RequestInit) => Promise<GetTransactionHistory200>;

  createSubscription: (createSubscriptionBody: CreateSubscriptionBody,
  options?: RequestInit) => Promise<CreateSubscription200>;

  cancelSubscription: (cancelSubscriptionBody: CancelSubscriptionBody,
  options?: RequestInit) => Promise<CancelSubscription200>;

  pauseSubscription: (pauseSubscriptionBody: PauseSubscriptionBody,
  options?: RequestInit) => Promise<PauseSubscription200>;

  resumeSubscription: (resumeSubscriptionBody: ResumeSubscriptionBody,
  options?: RequestInit) => Promise<ResumeSubscription200>;

  changeSubscriptionPlan: (changeSubscriptionPlanBody: ChangeSubscriptionPlanBody,
  options?: RequestInit) => Promise<ChangeSubscriptionPlan200>;

  grantFreeSubscription: (grantFreeSubscriptionBody: GrantFreeSubscriptionBody,
  options?: RequestInit) => Promise<GrantFreeSubscription200>;

  revokeGrant: (revokeGrantBody: RevokeGrantBody, options?: RequestInit) => Promise<RevokeGrant200>;

  createBillingPortalSession: (createBillingPortalSessionBody: CreateBillingPortalSessionBody,
  options?: RequestInit) => Promise<CreateBillingPortalSession200>;

  createSetupIntent: (createSetupIntentBody: CreateSetupIntentBody,
  options?: RequestInit) => Promise<CreateSetupIntent200>;

  getSuggestions: (params: GetSuggestionsParams,
  options?: RequestInit) => Promise<SearchSuggestionsResponse>;

  getUserById: (id: UserId, options?: RequestInit) => Promise<User>;

  updateUser: (id: UserId, updateUserBody: UpdateUserBody, options?: RequestInit) => Promise<User>;

  getUserActivities: (userId: UserId,
  params?: GetUserActivitiesParams,
  options?: RequestInit) => Promise<Activities>;

  getUsers: (params?: GetUsersParams, options?: RequestInit) => Promise<Users>;

  createUser: (createUserBody: CreateUserBody, options?: RequestInit) => Promise<User>;

  removeProfilePicture: (options?: RequestInit) => Promise<RemoveProfilePictureResponse>;

  blockUser: (userId: string,
  blockUserBody: BlockUserBody,
  options?: RequestInit) => Promise<BlockUserResponse>;

  unblockUser: (userId: string,
  unblockUserBody: UnblockUserBody,
  options?: RequestInit) => Promise<UnblockUserResponse>;
}

// ============================================================================
// Factory Function
// ============================================================================

/**
 * Creates an API client instance with the provided custom fetch implementation.
 *
 * @param customFetch - The fetch implementation to use for all API calls
 * @returns An API client with all methods bound to the custom fetch
 *
 * @example
 * ```ts
 * // Browser client with proxy routing
 * const browserFetch: CustomFetchFn = async (url, options) => {
 *   const response = await fetch(`/api/proxy${url}`, { ...options, credentials: 'include' });
 *   if (!response.ok) throw new Error(`HTTP ${response.status}`);
 *   return response.json();
 * };
 * export const BrowserApiClient = createApiClient(browserFetch);
 *
 * // Server client with direct API URL
 * const serverFetch: CustomFetchFn = async (url, options) => {
 *   const response = await fetch(`${process.env.API_URL}${url}`, options);
 *   if (!response.ok) throw new Error(`HTTP ${response.status}`);
 *   return response.json();
 * };
 * export const ServerApiClient = createApiClient(serverFetch);
 * ```
 */
export function createApiClient(customFetch: CustomFetchFn): ApiClient {
  return {
    getSession: async (options?: RequestInit): Promise<SessionResponse> => {return customFetch<SessionResponse>(getGetSessionUrl(), {
    authRequired: true,
    route: '/session',
    ...options,
    method: 'GET'
  });
    },

    getActivityById: async (id: ActivityId,
  params?: GetActivityByIdParams,
  options?: RequestInit): Promise<ActivityDetail> => {return customFetch<ActivityDetail>(getGetActivityByIdUrl(id, params), {
    authRequired: false,
    route: '/activities/${id}',
    ...options,
    method: 'GET'
  });
    },

    updateActivity: async (id: ActivityId,
  updateActivityBody: UpdateActivityBody,
  options?: RequestInit): Promise<Activity> => {return customFetch<Activity>(getUpdateActivityUrl(id), {
    authRequired: true,
    route: '/activities/${id}',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateActivityBody)
  });
    },

    removeActivity: async (id: ActivityId, options?: RequestInit): Promise<null> => {return customFetch<null>(getRemoveActivityUrl(id), {
    authRequired: true,
    route: '/activities/${id}',
    ...options,
    method: 'DELETE'
  });
    },

    getActivities: async (params?: GetActivitiesParams,
  options?: RequestInit): Promise<ActivitySearchResults> => {return customFetch<ActivitySearchResults>(getGetActivitiesUrl(params), {
    authRequired: false,
    route: '/activities',
    ...options,
    method: 'GET'
  });
    },

    createActivity: async (createActivityBody: CreateActivityBody,
  options?: RequestInit): Promise<Activity> => {return customFetch<Activity>(getCreateActivityUrl(), {
    authRequired: true,
    route: '/activities',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createActivityBody)
  });
    },

    getActivitiesAdmin: async (params?: GetActivitiesAdminParams,
  options?: RequestInit): Promise<AdminActivitySearchResults> => {return customFetch<AdminActivitySearchResults>(getGetActivitiesAdminUrl(params), {
    authRequired: true,
    route: '/admin/activities',
    ...options,
    method: 'GET'
  });
    },

    getActivitiesFeatured: async (params?: GetActivitiesFeaturedParams,
  options?: RequestInit): Promise<ActivityFeaturedResults> => {return customFetch<ActivityFeaturedResults>(getGetActivitiesFeaturedUrl(params), {
    authRequired: false,
    route: '/activities/featured',
    ...options,
    method: 'GET'
  });
    },

    improveActivityDescription: async (improveActivityDescriptionBody: ImproveActivityDescriptionBody,
  options?: RequestInit): Promise<ImproveActivityDescription200> => {return customFetch<ImproveActivityDescription200>(getImproveActivityDescriptionUrl(), {
    authRequired: true,
    route: '/activities/description/improve',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(improveActivityDescriptionBody)
  });
    },

    getActivityCacheInfo: async (activityId: ActivityId,
  options?: RequestInit): Promise<GetActivityCacheInfo200> => {return customFetch<GetActivityCacheInfo200>(getGetActivityCacheInfoUrl(activityId), {
    authRequired: true,
    route: '/activities/${activityId}/cache-info',
    ...options,
    method: 'GET'
  });
    },

    getActivityRevisions: async (activityId: ActivityId,
  options?: RequestInit): Promise<GetActivityRevisions200Item[]> => {return customFetch<GetActivityRevisions200Item[]>(getGetActivityRevisionsUrl(activityId), {
    authRequired: true,
    route: '/activities/${activityId}/revisions',
    ...options,
    method: 'GET'
  });
    },

    approveActivityRevision: async (activityId: ActivityId,
  approveActivityRevisionBody: ApproveActivityRevisionBody,
  options?: RequestInit): Promise<Activity> => {return customFetch<Activity>(getApproveActivityRevisionUrl(activityId), {
    authRequired: true,
    route: '/activities/${activityId}/revisions/approve',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveActivityRevisionBody)
  });
    },

    declineActivityRevision: async (activityId: ActivityId,
  declineActivityRevisionBody: DeclineActivityRevisionBody,
  options?: RequestInit): Promise<DeclineActivityRevision200> => {return customFetch<DeclineActivityRevision200>(getDeclineActivityRevisionUrl(activityId), {
    authRequired: true,
    route: '/activities/${activityId}/revisions/decline',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(declineActivityRevisionBody)
  });
    },

    getAssetUploadUrl: async (uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit): Promise<UploadUrlResponse> => {return customFetch<UploadUrlResponse>(getGetAssetUploadUrlUrl(), {
    authRequired: true,
    route: '/assets/upload-url',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  });
    },

    getPrivateAssetUploadUrl: async (getPrivateAssetUploadUrlBody: GetPrivateAssetUploadUrlBody,
  options?: RequestInit): Promise<UploadUrlResponse> => {return customFetch<UploadUrlResponse>(getGetPrivateAssetUploadUrlUrl(), {
    authRequired: false,
    route: '/assets/private/upload-url',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getPrivateAssetUploadUrlBody)
  });
    },

    getPrivateUserAssetUploadUrl: async (privateUserUploadUrlRequest: PrivateUserUploadUrlRequest,
  options?: RequestInit): Promise<GetPrivateUserAssetUploadUrl200> => {return customFetch<GetPrivateUserAssetUploadUrl200>(getGetPrivateUserAssetUploadUrlUrl(), {
    authRequired: true,
    route: '/assets/private/user/upload-url',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(privateUserUploadUrlRequest)
  });
    },

    getPrivateUserAssetDownloadUrl: async (privateUserDownloadUrlRequest: PrivateUserDownloadUrlRequest,
  options?: RequestInit): Promise<PrivateUserDownloadUrlResponse> => {return customFetch<PrivateUserDownloadUrlResponse>(getGetPrivateUserAssetDownloadUrlUrl(), {
    authRequired: true,
    route: '/assets/private/user/download-url',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(privateUserDownloadUrlRequest)
  });
    },

    deletePrivateAssets: async (deletePrivateAssetsBody: DeletePrivateAssetsBody,
  options?: RequestInit): Promise<null> => {return customFetch<null>(getDeletePrivateAssetsUrl(), {
    authRequired: false,
    route: '/assets/private/delete',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deletePrivateAssetsBody)
  });
    },

    deleteAssets: async (deleteAssetsBody: DeleteAssetsBody, options?: RequestInit): Promise<null> => {return customFetch<null>(getDeleteAssetsUrl(), {
    authRequired: true,
    route: '/assets/delete',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deleteAssetsBody)
  });
    },

    getAuditEvents: async (params?: GetAuditEventsParams,
  options?: RequestInit): Promise<GetAuditEventsResponse> => {return customFetch<GetAuditEventsResponse>(getGetAuditEventsUrl(params), {
    authRequired: true,
    route: '/admin/audit-events',
    ...options,
    method: 'GET'
  });
    },

    getAvailableSlots: async (getAvailableSlotsInput: GetAvailableSlotsInput,
  options?: RequestInit): Promise<GetAvailableSlotsOutput> => {return customFetch<GetAvailableSlotsOutput>(getGetAvailableSlotsUrl(), {
    authRequired: true,
    route: '/bookings/available-slots',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getAvailableSlotsInput)
  });
    },

    createBooking: async (createBookingBody: CreateBookingBody,
  options?: RequestInit): Promise<BookingResponse> => {return customFetch<BookingResponse>(getCreateBookingUrl(), {
    authRequired: true,
    route: '/bookings',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createBookingBody)
  });
    },

    getUserBookings: async (params?: GetUserBookingsParams,
  options?: RequestInit): Promise<GetUserBookingsResponse> => {return customFetch<GetUserBookingsResponse>(getGetUserBookingsUrl(params), {
    authRequired: true,
    route: '/bookings',
    ...options,
    method: 'GET'
  });
    },

    getBookingById: async (id: string,
  params?: GetBookingByIdParams,
  options?: RequestInit): Promise<GetBookingByIdResponse> => {return customFetch<GetBookingByIdResponse>(getGetBookingByIdUrl(id, params), {
    authRequired: true,
    route: '/bookings/${id}',
    ...options,
    method: 'GET'
  });
    },

    updateBooking: async (id: string,
  updateBookingBody: UpdateBookingBody,
  options?: RequestInit): Promise<BookingResponse> => {return customFetch<BookingResponse>(getUpdateBookingUrl(id), {
    authRequired: true,
    route: '/bookings/${id}',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateBookingBody)
  });
    },

    deleteBooking: async (id: string,
  params?: DeleteBookingParams,
  options?: RequestInit): Promise<DeleteBookingResponse> => {return customFetch<DeleteBookingResponse>(getDeleteBookingUrl(id, params), {
    authRequired: true,
    route: '/bookings/${id}',
    ...options,
    method: 'DELETE'
  });
    },

    getProfessionalBookings: async (params?: GetProfessionalBookingsParams,
  options?: RequestInit): Promise<GetProfessionalBookingsResponse> => {return customFetch<GetProfessionalBookingsResponse>(getGetProfessionalBookingsUrl(params), {
    authRequired: true,
    route: '/professional-bookings',
    ...options,
    method: 'GET'
  });
    },

    createProfessionalBooking: async (professionalBooking: ProfessionalBooking,
  options?: RequestInit): Promise<ProfessionalBookingBaseResponse> => {return customFetch<ProfessionalBookingBaseResponse>(getCreateProfessionalBookingUrl(), {
    authRequired: true,
    route: '/professional-bookings',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(professionalBooking)
  });
    },

    updateProfessionalBooking: async (id: string,
  updateProfessionalBookingBody: UpdateProfessionalBookingBody,
  options?: RequestInit): Promise<ProfessionalBookingBaseResponse> => {return customFetch<ProfessionalBookingBaseResponse>(getUpdateProfessionalBookingUrl(id), {
    authRequired: true,
    route: '/professional-bookings/${id}',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProfessionalBookingBody)
  });
    },

    deleteProfessionalBooking: async (id: string,
  params?: DeleteProfessionalBookingParams,
  options?: RequestInit): Promise<DeleteBookingResponse> => {return customFetch<DeleteBookingResponse>(getDeleteProfessionalBookingUrl(id, params), {
    authRequired: true,
    route: '/professional-bookings/${id}',
    ...options,
    method: 'DELETE'
  });
    },

    openDispute: async (id: string,
  openDisputeBody: OpenDisputeBody,
  options?: RequestInit): Promise<OpenDisputeResponse> => {return customFetch<OpenDisputeResponse>(getOpenDisputeUrl(id), {
    authRequired: true,
    route: '/bookings/${id}/dispute',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(openDisputeBody)
  });
    },

    resolveDispute: async (id: string,
  resolveDisputeBody: ResolveDisputeBody,
  options?: RequestInit): Promise<ResolveDisputeResponse> => {return customFetch<ResolveDisputeResponse>(getResolveDisputeUrl(id), {
    authRequired: true,
    route: '/bookings/${id}/dispute/resolve',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resolveDisputeBody)
  });
    },

    initiatePaymentForCashBooking: async (id: string,
  initiatePaymentForCashBookingBody: InitiatePaymentForCashBookingBody,
  options?: RequestInit): Promise<InitiatePaymentForCashBooking200> => {return customFetch<InitiatePaymentForCashBooking200>(getInitiatePaymentForCashBookingUrl(id), {
    authRequired: true,
    route: '/bookings/${id}/initiate-payment',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(initiatePaymentForCashBookingBody)
  });
    },

    markAttendance: async (id: string,
  markAttendanceBody: MarkAttendanceBody,
  options?: RequestInit): Promise<MarkAttendanceResponse> => {return customFetch<MarkAttendanceResponse>(getMarkAttendanceUrl(id), {
    authRequired: true,
    route: '/bookings/${id}/attendance',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(markAttendanceBody)
  });
    },

    confirmBooking: async (id: string,
  confirmBookingBody: ConfirmBookingBody,
  options?: RequestInit): Promise<BookingResponse> => {return customFetch<BookingResponse>(getConfirmBookingUrl(id), {
    authRequired: true,
    route: '/bookings/${id}/confirm',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmBookingBody)
  });
    },

    generateToken: async (options?: RequestInit): Promise<GenerateCalendarTokenOutput> => {return customFetch<GenerateCalendarTokenOutput>(getGenerateTokenUrl(), {
    authRequired: true,
    route: '/calendar/token',
    ...options,
    method: 'GET'
  });
    },

    revokeToken: async (options?: RequestInit): Promise<RevokeCalendarTokenOutput> => {return customFetch<RevokeCalendarTokenOutput>(getRevokeTokenUrl(), {
    authRequired: true,
    route: '/calendar/token',
    ...options,
    method: 'DELETE'
  });
    },

    getCalendarFeed: async (params: GetCalendarFeedParams,
  options?: RequestInit): Promise<GetCalendarFeedOutput> => {return customFetch<GetCalendarFeedOutput>(getGetCalendarFeedUrl(params), {
    authRequired: false,
    route: '/calendar/feed.ics',
    ...options,
    method: 'GET'
  });
    },

    getCategories: async (options?: RequestInit): Promise<ListCategoriesResponse> => {return customFetch<ListCategoriesResponse>(getGetCategoriesUrl(), {
    authRequired: false,
    route: '/categories',
    ...options,
    method: 'GET'
  });
    },

    createCategory: async (createCategoryRequest: CreateCategoryRequest,
  options?: RequestInit): Promise<CreateCategoryResponse> => {return customFetch<CreateCategoryResponse>(getCreateCategoryUrl(), {
    authRequired: true,
    route: '/categories',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCategoryRequest)
  });
    },

    deleteCategory: async (id: CategoryId, options?: RequestInit): Promise<DeleteCategoryResponse> => {return customFetch<DeleteCategoryResponse>(getDeleteCategoryUrl(id), {
    authRequired: true,
    route: '/categories/${id}',
    ...options,
    method: 'DELETE'
  });
    },

    getAdminDashboardStats: async (options?: RequestInit): Promise<GetAdminDashboardStats200> => {return customFetch<GetAdminDashboardStats200>(getGetAdminDashboardStatsUrl(), {
    authRequired: true,
    route: '/admin/dashboard/stats',
    ...options,
    method: 'GET'
  });
    },

    getDashboardOverview: async (params?: GetDashboardOverviewParams,
  options?: RequestInit): Promise<DashboardOverviewResponse> => {return customFetch<DashboardOverviewResponse>(getGetDashboardOverviewUrl(params), {
    authRequired: true,
    route: '/dashboard/overview',
    ...options,
    method: 'GET'
  });
    },

    getDashboardCashflow: async (params: GetDashboardCashflowParams,
  options?: RequestInit): Promise<DashboardCashflowResponse> => {return customFetch<DashboardCashflowResponse>(getGetDashboardCashflowUrl(params), {
    authRequired: true,
    route: '/dashboard/cashflow',
    ...options,
    method: 'GET'
  });
    },

    getDashboardBookingsChart: async (params: GetDashboardBookingsChartParams,
  options?: RequestInit): Promise<DashboardBookingsChartResponse> => {return customFetch<DashboardBookingsChartResponse>(getGetDashboardBookingsChartUrl(params), {
    authRequired: true,
    route: '/dashboard/bookings-chart',
    ...options,
    method: 'GET'
  });
    },

    getDashboardMentees: async (options?: RequestInit): Promise<DashboardMenteesResponse> => {return customFetch<DashboardMenteesResponse>(getGetDashboardMenteesUrl(), {
    authRequired: true,
    route: '/dashboard/mentees',
    ...options,
    method: 'GET'
  });
    },

    getProfessionalDashboardBookings: async (params?: GetProfessionalDashboardBookingsParams,
  options?: RequestInit): Promise<DashboardBookingsResponse> => {return customFetch<DashboardBookingsResponse>(getGetProfessionalDashboardBookingsUrl(params), {
    authRequired: true,
    route: '/dashboard/bookings',
    ...options,
    method: 'GET'
  });
    },

    getProfessionalDashboardEarnings: async (params?: GetProfessionalDashboardEarningsParams,
  options?: RequestInit): Promise<DashboardEarningsResponse> => {return customFetch<DashboardEarningsResponse>(getGetProfessionalDashboardEarningsUrl(params), {
    authRequired: true,
    route: '/dashboard/earnings',
    ...options,
    method: 'GET'
  });
    },

    getProfessionalDashboardMetrics: async (params?: GetProfessionalDashboardMetricsParams,
  options?: RequestInit): Promise<DashboardMetricsResponse> => {return customFetch<DashboardMetricsResponse>(getGetProfessionalDashboardMetricsUrl(params), {
    authRequired: true,
    route: '/dashboard/metrics',
    ...options,
    method: 'GET'
  });
    },

    getAdminDisputes: async (params?: GetAdminDisputesParams,
  options?: RequestInit): Promise<GetAdminDisputesResponse> => {return customFetch<GetAdminDisputesResponse>(getGetAdminDisputesUrl(params), {
    authRequired: true,
    route: '/admin/disputes',
    ...options,
    method: 'GET'
  });
    },

    blockProfessional: async (professionalId: string,
  blockProfessionalBody: BlockProfessionalBody,
  options?: RequestInit): Promise<BlockProfessionalResponse> => {return customFetch<BlockProfessionalResponse>(getBlockProfessionalUrl(professionalId), {
    authRequired: true,
    route: '/admin/professionals/${professionalId}/block',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(blockProfessionalBody)
  });
    },

    unblockProfessional: async (professionalId: string,
  unblockProfessionalBody: UnblockProfessionalBody,
  options?: RequestInit): Promise<UnblockProfessionalResponse> => {return customFetch<UnblockProfessionalResponse>(getUnblockProfessionalUrl(professionalId), {
    authRequired: true,
    route: '/admin/professionals/${professionalId}/unblock',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(unblockProfessionalBody)
  });
    },

    listGroups: async (options?: RequestInit): Promise<ListGroupsResponse> => {return customFetch<ListGroupsResponse>(getListGroupsUrl(), {
    authRequired: true,
    route: '/admin/groups',
    ...options,
    method: 'GET'
  });
    },

    createGroup: async (createGroupRequest: CreateGroupRequest,
  options?: RequestInit): Promise<CreateGroupResponse> => {return customFetch<CreateGroupResponse>(getCreateGroupUrl(), {
    authRequired: true,
    route: '/admin/groups',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createGroupRequest)
  });
    },

    updateGroup: async (id: GroupId,
  params?: UpdateGroupParams,
  options?: RequestInit): Promise<UpdateGroupResponse> => {return customFetch<UpdateGroupResponse>(getUpdateGroupUrl(id, params), {
    authRequired: true,
    route: '/admin/groups/${id}',
    ...options,
    method: 'PATCH'
  });
    },

    deleteGroup: async (id: GroupId, options?: RequestInit): Promise<DeleteGroupResponse> => {return customFetch<DeleteGroupResponse>(getDeleteGroupUrl(id), {
    authRequired: true,
    route: '/admin/groups/${id}',
    ...options,
    method: 'DELETE'
  });
    },

    assignUserGroups: async (id: UserId,
  assignUserGroupsBody: AssignUserGroupsBody,
  options?: RequestInit): Promise<AssignUserGroupsResponse> => {return customFetch<AssignUserGroupsResponse>(getAssignUserGroupsUrl(id), {
    authRequired: true,
    route: '/admin/users/${id}/groups',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assignUserGroupsBody)
  });
    },

    assignActivityScopes: async (id: ActivityId,
  assignActivityScopesBody: AssignActivityScopesBody,
  options?: RequestInit): Promise<AssignActivityScopesResponse> => {return customFetch<AssignActivityScopesResponse>(getAssignActivityScopesUrl(id), {
    authRequired: true,
    route: '/admin/activities/${id}/scopes',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assignActivityScopesBody)
  });
    },

    listNotifications: async (params?: ListNotificationsParams,
  options?: RequestInit): Promise<ListNotifications200> => {return customFetch<ListNotifications200>(getListNotificationsUrl(params), {
    authRequired: true,
    route: '/notifications',
    ...options,
    method: 'GET'
  });
    },

    getUnreadCount: async (params?: GetUnreadCountParams,
  options?: RequestInit): Promise<GetUnreadCount200> => {return customFetch<GetUnreadCount200>(getGetUnreadCountUrl(params), {
    authRequired: true,
    route: '/notifications/unread-count',
    ...options,
    method: 'GET'
  });
    },

    markAsRead: async (id: string,
  params?: MarkAsReadParams,
  options?: RequestInit): Promise<MarkAsRead200> => {return customFetch<MarkAsRead200>(getMarkAsReadUrl(id, params), {
    authRequired: true,
    route: '/notifications/${id}/read',
    ...options,
    method: 'PATCH'
  });
    },

    markAllAsRead: async (params?: MarkAllAsReadParams, options?: RequestInit): Promise<MarkAllAsRead200> => {return customFetch<MarkAllAsRead200>(getMarkAllAsReadUrl(params), {
    authRequired: true,
    route: '/notifications/read-all',
    ...options,
    method: 'PATCH'
  });
    },

    deleteNotification: async (id: string,
  params?: DeleteNotificationParams,
  options?: RequestInit): Promise<DeleteNotification200> => {return customFetch<DeleteNotification200>(getDeleteNotificationUrl(id, params), {
    authRequired: true,
    route: '/notifications/${id}',
    ...options,
    method: 'DELETE'
  });
    },

    getNotificationPreferences: async (params?: GetNotificationPreferencesParams,
  options?: RequestInit): Promise<GetNotificationPreferences200> => {return customFetch<GetNotificationPreferences200>(getGetNotificationPreferencesUrl(params), {
    authRequired: true,
    route: '/notifications/preferences',
    ...options,
    method: 'GET'
  });
    },

    upsertNotificationPreferences: async (upsertNotificationPreferencesBody: UpsertNotificationPreferencesBody,
  options?: RequestInit): Promise<UpsertNotificationPreferences200> => {return customFetch<UpsertNotificationPreferences200>(getUpsertNotificationPreferencesUrl(), {
    authRequired: true,
    route: '/notifications/preferences',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertNotificationPreferencesBody)
  });
    },

    getVapidPublicKey: async (options?: RequestInit): Promise<GetVapidPublicKey200> => {return customFetch<GetVapidPublicKey200>(getGetVapidPublicKeyUrl(), {
    authRequired: false,
    route: '/push/vapid-public-key',
    ...options,
    method: 'GET'
  });
    },

    subscribePush: async (subscribePushBody: SubscribePushBody,
  options?: RequestInit): Promise<SubscribePush200> => {return customFetch<SubscribePush200>(getSubscribePushUrl(), {
    authRequired: true,
    route: '/push/subscribe',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(subscribePushBody)
  });
    },

    unsubscribePush: async (params: UnsubscribePushParams,
  options?: RequestInit): Promise<UnsubscribePush200> => {return customFetch<UnsubscribePush200>(getUnsubscribePushUrl(params), {
    authRequired: true,
    route: '/push/subscribe',
    ...options,
    method: 'DELETE'
  });
    },

    sendOtp: async (sendOtpBody: SendOtpBody, options?: RequestInit): Promise<SendOtp200> => {return customFetch<SendOtp200>(getSendOtpUrl(), {
    authRequired: true,
    route: '/otp/send',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendOtpBody)
  });
    },

    verifyOtp: async (verifyOtpBody: VerifyOtpBody, options?: RequestInit): Promise<VerifyOtp200> => {return customFetch<VerifyOtp200>(getVerifyOtpUrl(), {
    authRequired: true,
    route: '/otp/verify',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyOtpBody)
  });
    },

    getProfessionalPublicProfile: async (id: UserId,
  options?: RequestInit): Promise<ProfessionalPublicProfile> => {return customFetch<ProfessionalPublicProfile>(getGetProfessionalPublicProfileUrl(id), {
    authRequired: false,
    route: '/professionals/${id}',
    ...options,
    method: 'GET'
  });
    },

    updateProfessional: async (id: UserId,
  updateProfessionalBody: UpdateProfessionalBody,
  options?: RequestInit): Promise<ProfessionalResponse> => {return customFetch<ProfessionalResponse>(getUpdateProfessionalUrl(id), {
    authRequired: true,
    route: '/professionals/${id}',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProfessionalBody)
  });
    },

    getProfessionalPrivateProfile: async (id: UserId,
  options?: RequestInit): Promise<ProfessionalPrivateProfile> => {return customFetch<ProfessionalPrivateProfile>(getGetProfessionalPrivateProfileUrl(id), {
    authRequired: true,
    route: '/professionals/${id}/private-profile',
    ...options,
    method: 'GET'
  });
    },

    getProfessionalAdminProfile: async (id: UserId,
  options?: RequestInit): Promise<ProfessionalAdminProfile> => {return customFetch<ProfessionalAdminProfile>(getGetProfessionalAdminProfileUrl(id), {
    authRequired: true,
    route: '/professionals/${id}/admin-profile',
    ...options,
    method: 'GET'
  });
    },

    getProfessionalsAdmin: async (params?: GetProfessionalsAdminParams,
  options?: RequestInit): Promise<ProfessionalsAdmin> => {return customFetch<ProfessionalsAdmin>(getGetProfessionalsAdminUrl(params), {
    authRequired: true,
    route: '/admin/professionals',
    ...options,
    method: 'GET'
  });
    },

    getProfessionals: async (params?: GetProfessionalsParams,
  options?: RequestInit): Promise<Professionals> => {return customFetch<Professionals>(getGetProfessionalsUrl(params), {
    authRequired: true,
    route: '/professionals',
    ...options,
    method: 'GET'
  });
    },

    createProfessional: async (createProfessionalBody: CreateProfessionalBody,
  options?: RequestInit): Promise<ProfessionalResponse> => {return customFetch<ProfessionalResponse>(getCreateProfessionalUrl(), {
    authRequired: true,
    route: '/professionals',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProfessionalBody)
  });
    },

    getProfessionalActivities: async (id: UserId,
  params?: GetProfessionalActivitiesParams,
  options?: RequestInit): Promise<ProfessionalActivityList> => {return customFetch<ProfessionalActivityList>(getGetProfessionalActivitiesUrl(id, params), {
    authRequired: false,
    route: '/professionals/${id}/activities',
    ...options,
    method: 'GET'
  });
    },

    getProfessionalCacheInfo: async (id: UserId,
  options?: RequestInit): Promise<GetProfessionalCacheInfo200> => {return customFetch<GetProfessionalCacheInfo200>(getGetProfessionalCacheInfoUrl(id), {
    authRequired: true,
    route: '/professionals/${id}/cache-info',
    ...options,
    method: 'GET'
  });
    },

    approveProfessionalRevision: async (professionalId: UserId,
  approveProfessionalRevisionBody: ApproveProfessionalRevisionBody,
  options?: RequestInit): Promise<ProfessionalResponse> => {return customFetch<ProfessionalResponse>(getApproveProfessionalRevisionUrl(professionalId), {
    authRequired: true,
    route: '/professionals/${professionalId}/revisions/approve',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveProfessionalRevisionBody)
  });
    },

    declineProfessionalRevision: async (professionalId: UserId,
  declineProfessionalRevisionBody: DeclineProfessionalRevisionBody,
  options?: RequestInit): Promise<ProfessionalRevision> => {return customFetch<ProfessionalRevision>(getDeclineProfessionalRevisionUrl(professionalId), {
    authRequired: true,
    route: '/professionals/${professionalId}/revisions/decline',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(declineProfessionalRevisionBody)
  });
    },

    improveProfessionalBio: async (improveProfessionalBioBody: ImproveProfessionalBioBody,
  options?: RequestInit): Promise<ImproveProfessionalBio200> => {return customFetch<ImproveProfessionalBio200>(getImproveProfessionalBioUrl(), {
    authRequired: true,
    route: '/professionals/bio/improve',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(improveProfessionalBioBody)
  });
    },

    sendQuery: async (sendQueryParams: SendQueryParams,
  options?: RequestInit): Promise<SendQueryResponse> => {return customFetch<SendQueryResponse>(getSendQueryUrl(), {
    authRequired: false,
    route: '/queries/send',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendQueryParams)
  });
    },

    getReviewsByActivityId: async (activityId: ActivityId,
  params?: GetReviewsByActivityIdParams,
  options?: RequestInit): Promise<Reviews> => {return customFetch<Reviews>(getGetReviewsByActivityIdUrl(activityId, params), {
    authRequired: false,
    route: '/activities/${activityId}/reviews',
    ...options,
    method: 'GET'
  });
    },

    createReview: async (activityId: ActivityId,
  createReviewBody: CreateReviewBody,
  options?: RequestInit): Promise<Review> => {return customFetch<Review>(getCreateReviewUrl(activityId), {
    authRequired: true,
    route: '/activities/${activityId}/reviews',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createReviewBody)
  });
    },

    updateReviewStatus: async (reviewId: string,
  params: UpdateReviewStatusParams,
  options?: RequestInit): Promise<Review> => {return customFetch<Review>(getUpdateReviewStatusUrl(reviewId, params), {
    authRequired: true,
    route: '/reviews/${reviewId}/status',
    ...options,
    method: 'PATCH'
  });
    },

    createSavedAddress: async (createSavedAddress: CreateSavedAddress,
  options?: RequestInit): Promise<SavedAddress> => {return customFetch<SavedAddress>(getCreateSavedAddressUrl(), {
    authRequired: true,
    route: '/saved-addresses',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSavedAddress)
  });
    },

    getSavedAddresses: async (options?: RequestInit): Promise<SavedAddress[]> => {return customFetch<SavedAddress[]>(getGetSavedAddressesUrl(), {
    authRequired: true,
    route: '/saved-addresses',
    ...options,
    method: 'GET'
  });
    },

    getSavedAddressById: async (id: SavedAddressId, options?: RequestInit): Promise<SavedAddress> => {return customFetch<SavedAddress>(getGetSavedAddressByIdUrl(id), {
    authRequired: true,
    route: '/saved-addresses/${id}',
    ...options,
    method: 'GET'
  });
    },

    updateSavedAddress: async (id: SavedAddressId,
  updateSavedAddressBody: UpdateSavedAddressBody,
  options?: RequestInit): Promise<SavedAddress> => {return customFetch<SavedAddress>(getUpdateSavedAddressUrl(id), {
    authRequired: true,
    route: '/saved-addresses/${id}',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSavedAddressBody)
  });
    },

    deleteSavedAddress: async (id: SavedAddressId, options?: RequestInit): Promise<DeleteSavedAddress200> => {return customFetch<DeleteSavedAddress200>(getDeleteSavedAddressUrl(id), {
    authRequired: true,
    route: '/saved-addresses/${id}',
    ...options,
    method: 'DELETE'
  });
    },

    createSession: async (createSessionBody: CreateSessionBody, options?: RequestInit): Promise<Session> => {return customFetch<Session>(getCreateSessionUrl(), {
    authRequired: true,
    route: '/sessions',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSessionBody)
  });
    },

    getSessionById: async (id: string,
  params?: GetSessionByIdParams,
  options?: RequestInit): Promise<Session> => {return customFetch<Session>(getGetSessionByIdUrl(id, params), {
    authRequired: false,
    route: '/sessions/${id}',
    ...options,
    method: 'GET'
  });
    },

    updateSession: async (id: SessionId,
  updateSessionBody: UpdateSessionBody,
  options?: RequestInit): Promise<Session> => {return customFetch<Session>(getUpdateSessionUrl(id), {
    authRequired: true,
    route: '/sessions/${id}',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSessionBody)
  });
    },

    deleteSession: async (id: SessionId, options?: RequestInit): Promise<DeleteSession200> => {return customFetch<DeleteSession200>(getDeleteSessionUrl(id), {
    authRequired: true,
    route: '/sessions/${id}',
    ...options,
    method: 'DELETE'
  });
    },

    archiveSession: async (id: SessionId,
  archiveSessionBody: ArchiveSessionBody,
  options?: RequestInit): Promise<Session> => {return customFetch<Session>(getArchiveSessionUrl(id), {
    authRequired: true,
    route: '/sessions/${id}/archive',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(archiveSessionBody)
  });
    },

    restoreSession: async (id: SessionId,
  restoreSessionBody: RestoreSessionBody,
  options?: RequestInit): Promise<Session> => {return customFetch<Session>(getRestoreSessionUrl(id), {
    authRequired: true,
    route: '/sessions/${id}/restore',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(restoreSessionBody)
  });
    },

    cancelSlotOccurrence: async (cancelSlotOccurrenceBody: CancelSlotOccurrenceBody,
  options?: RequestInit): Promise<Slot> => {return customFetch<Slot>(getCancelSlotOccurrenceUrl(), {
    authRequired: true,
    route: '/slots/cancel',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelSlotOccurrenceBody)
  });
    },

    getSlotsByActivity: async (params: GetSlotsByActivityParams, options?: RequestInit): Promise<Slot[]> => {return customFetch<Slot[]>(getGetSlotsByActivityUrl(params), {
    authRequired: false,
    route: '/slots/by-activity',
    ...options,
    method: 'GET'
  });
    },

    removeTimeslotRecursively: async (removeTimeslotRecursivelyBody: RemoveTimeslotRecursivelyBody,
  options?: RequestInit): Promise<RemoveTimeslotRecursively200> => {return customFetch<RemoveTimeslotRecursively200>(getRemoveTimeslotRecursivelyUrl(), {
    authRequired: true,
    route: '/slots/remove-recursive',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(removeTimeslotRecursivelyBody)
  });
    },

    updateSlotOccurrence: async (updateSlotOccurrenceBody: UpdateSlotOccurrenceBody,
  options?: RequestInit): Promise<Slot> => {return customFetch<Slot>(getUpdateSlotOccurrenceUrl(), {
    authRequired: true,
    route: '/slots/update-occurrence',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSlotOccurrenceBody)
  });
    },

    createStripeAccount: async (createStripeAccountBody: CreateStripeAccountBody,
  options?: RequestInit): Promise<CreateStripeAccount200> => {return customFetch<CreateStripeAccount200>(getCreateStripeAccountUrl(), {
    authRequired: true,
    route: '/stripe/account',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createStripeAccountBody)
  });
    },

    createAccountSession: async (createAccountSessionBody: CreateAccountSessionBody,
  options?: RequestInit): Promise<CreateAccountSession200> => {return customFetch<CreateAccountSession200>(getCreateAccountSessionUrl(), {
    authRequired: true,
    route: '/stripe/account-session',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAccountSessionBody)
  });
    },

    createAccountLink: async (createAccountLinkBody: CreateAccountLinkBody,
  options?: RequestInit): Promise<CreateAccountLink200> => {return customFetch<CreateAccountLink200>(getCreateAccountLinkUrl(), {
    authRequired: true,
    route: '/stripe/account-link',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAccountLinkBody)
  });
    },

    getStripeAccountStatus: async (professionalId: string,
  options?: RequestInit): Promise<GetStripeAccountStatus200> => {return customFetch<GetStripeAccountStatus200>(getGetStripeAccountStatusUrl(professionalId), {
    authRequired: true,
    route: '/stripe/account-status/${professionalId}',
    ...options,
    method: 'GET'
  });
    },

    getProfessionalPaymentsDashboard: async (professionalId: string,
  options?: RequestInit): Promise<GetProfessionalPaymentsDashboard200> => {return customFetch<GetProfessionalPaymentsDashboard200>(
    getGetProfessionalPaymentsDashboardUrl(professionalId),
    {
      authRequired: true,
      route: '/stripe/payments-dashboard/${professionalId}',
      ...options,
      method: 'GET'
    }
  );
    },

    createDashboardLoginLink: async (createDashboardLoginLinkBody: CreateDashboardLoginLinkBody,
  options?: RequestInit): Promise<CreateDashboardLoginLink200> => {return customFetch<CreateDashboardLoginLink200>(getCreateDashboardLoginLinkUrl(), {
    authRequired: true,
    route: '/stripe/dashboard-login-link',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDashboardLoginLinkBody)
  });
    },

    createPaymentIntent: async (createPaymentIntentBody: CreatePaymentIntentBody,
  options?: RequestInit): Promise<CreatePaymentIntent200> => {return customFetch<CreatePaymentIntent200>(getCreatePaymentIntentUrl(), {
    authRequired: true,
    route: '/stripe/payment-intent',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPaymentIntentBody)
  });
    },

    startPayment: async (startPaymentBody: StartPaymentBody,
  options?: RequestInit): Promise<StartPayment200> => {return customFetch<StartPayment200>(getStartPaymentUrl(), {
    authRequired: true,
    route: '/stripe/start-payment',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(startPaymentBody)
  });
    },

    handleWebhook: async (handleWebhookBody: HandleWebhookBody,
  options?: RequestInit): Promise<HandleWebhook200> => {return customFetch<HandleWebhook200>(getHandleWebhookUrl(), {
    authRequired: false,
    route: '/stripe/webhook',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(handleWebhookBody)
  });
    },

    getSubscriptionPlans: async (options?: RequestInit): Promise<GetSubscriptionPlans200> => {return customFetch<GetSubscriptionPlans200>(getGetSubscriptionPlansUrl(), {
    authRequired: false,
    route: '/subscriptions/plans',
    ...options,
    method: 'GET'
  });
    },

    getSubscriptionStatus: async (professionalId: string,
  options?: RequestInit): Promise<GetSubscriptionStatus200> => {return customFetch<GetSubscriptionStatus200>(getGetSubscriptionStatusUrl(professionalId), {
    authRequired: true,
    route: '/subscriptions/status/${professionalId}',
    ...options,
    method: 'GET'
  });
    },

    getTransactionHistory: async (professionalId: string,
  params?: GetTransactionHistoryParams,
  options?: RequestInit): Promise<GetTransactionHistory200> => {return customFetch<GetTransactionHistory200>(getGetTransactionHistoryUrl(professionalId, params), {
    authRequired: true,
    route: '/subscriptions/transactions/${professionalId}',
    ...options,
    method: 'GET'
  });
    },

    createSubscription: async (createSubscriptionBody: CreateSubscriptionBody,
  options?: RequestInit): Promise<CreateSubscription200> => {return customFetch<CreateSubscription200>(getCreateSubscriptionUrl(), {
    authRequired: true,
    route: '/subscriptions/subscribe',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSubscriptionBody)
  });
    },

    cancelSubscription: async (cancelSubscriptionBody: CancelSubscriptionBody,
  options?: RequestInit): Promise<CancelSubscription200> => {return customFetch<CancelSubscription200>(getCancelSubscriptionUrl(), {
    authRequired: true,
    route: '/subscriptions/cancel',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelSubscriptionBody)
  });
    },

    pauseSubscription: async (pauseSubscriptionBody: PauseSubscriptionBody,
  options?: RequestInit): Promise<PauseSubscription200> => {return customFetch<PauseSubscription200>(getPauseSubscriptionUrl(), {
    authRequired: true,
    route: '/subscriptions/pause',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pauseSubscriptionBody)
  });
    },

    resumeSubscription: async (resumeSubscriptionBody: ResumeSubscriptionBody,
  options?: RequestInit): Promise<ResumeSubscription200> => {return customFetch<ResumeSubscription200>(getResumeSubscriptionUrl(), {
    authRequired: true,
    route: '/subscriptions/resume',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resumeSubscriptionBody)
  });
    },

    changeSubscriptionPlan: async (changeSubscriptionPlanBody: ChangeSubscriptionPlanBody,
  options?: RequestInit): Promise<ChangeSubscriptionPlan200> => {return customFetch<ChangeSubscriptionPlan200>(getChangeSubscriptionPlanUrl(), {
    authRequired: true,
    route: '/subscriptions/change-plan',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changeSubscriptionPlanBody)
  });
    },

    grantFreeSubscription: async (grantFreeSubscriptionBody: GrantFreeSubscriptionBody,
  options?: RequestInit): Promise<GrantFreeSubscription200> => {return customFetch<GrantFreeSubscription200>(getGrantFreeSubscriptionUrl(), {
    authRequired: true,
    route: '/subscriptions/grant',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(grantFreeSubscriptionBody)
  });
    },

    revokeGrant: async (revokeGrantBody: RevokeGrantBody, options?: RequestInit): Promise<RevokeGrant200> => {return customFetch<RevokeGrant200>(getRevokeGrantUrl(), {
    authRequired: true,
    route: '/subscriptions/revoke-grant',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(revokeGrantBody)
  });
    },

    createBillingPortalSession: async (createBillingPortalSessionBody: CreateBillingPortalSessionBody,
  options?: RequestInit): Promise<CreateBillingPortalSession200> => {return customFetch<CreateBillingPortalSession200>(getCreateBillingPortalSessionUrl(), {
    authRequired: true,
    route: '/subscriptions/billing-portal',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createBillingPortalSessionBody)
  });
    },

    createSetupIntent: async (createSetupIntentBody: CreateSetupIntentBody,
  options?: RequestInit): Promise<CreateSetupIntent200> => {return customFetch<CreateSetupIntent200>(getCreateSetupIntentUrl(), {
    authRequired: true,
    route: '/subscriptions/setup-intent',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSetupIntentBody)
  });
    },

    getSuggestions: async (params: GetSuggestionsParams,
  options?: RequestInit): Promise<SearchSuggestionsResponse> => {return customFetch<SearchSuggestionsResponse>(getGetSuggestionsUrl(params), {
    authRequired: false,
    route: '/suggestions',
    ...options,
    method: 'GET'
  });
    },

    getUserById: async (id: UserId, options?: RequestInit): Promise<User> => {return customFetch<User>(getGetUserByIdUrl(id), {
    authRequired: true,
    route: '/users/${id}',
    ...options,
    method: 'GET'
  });
    },

    updateUser: async (id: UserId, updateUserBody: UpdateUserBody, options?: RequestInit): Promise<User> => {return customFetch<User>(getUpdateUserUrl(id), {
    authRequired: true,
    route: '/users/${id}',
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateUserBody)
  });
    },

    getUserActivities: async (userId: UserId,
  params?: GetUserActivitiesParams,
  options?: RequestInit): Promise<Activities> => {return customFetch<Activities>(getGetUserActivitiesUrl(userId, params), {
    authRequired: false,
    route: '/users/${userId}/activities',
    ...options,
    method: 'GET'
  });
    },

    getUsers: async (params?: GetUsersParams, options?: RequestInit): Promise<Users> => {return customFetch<Users>(getGetUsersUrl(params), {
    authRequired: true,
    route: '/users',
    ...options,
    method: 'GET'
  });
    },

    createUser: async (createUserBody: CreateUserBody, options?: RequestInit): Promise<User> => {return customFetch<User>(getCreateUserUrl(), {
    authRequired: true,
    route: '/users',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUserBody)
  });
    },

    removeProfilePicture: async (options?: RequestInit): Promise<RemoveProfilePictureResponse> => {return customFetch<RemoveProfilePictureResponse>(getRemoveProfilePictureUrl(), {
    authRequired: true,
    route: '/users/profile-picture',
    ...options,
    method: 'DELETE'
  });
    },

    blockUser: async (userId: string,
  blockUserBody: BlockUserBody,
  options?: RequestInit): Promise<BlockUserResponse> => {return customFetch<BlockUserResponse>(getBlockUserUrl(userId), {
    authRequired: true,
    route: '/admin/users/${userId}/block',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(blockUserBody)
  });
    },

    unblockUser: async (userId: string,
  unblockUserBody: UnblockUserBody,
  options?: RequestInit): Promise<UnblockUserResponse> => {return customFetch<UnblockUserResponse>(getUnblockUserUrl(userId), {
    authRequired: true,
    route: '/admin/users/${userId}/unblock',
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(unblockUserBody)
  });
    }
  };
}

// ============================================================================
// Re-export types
// ============================================================================

export type { CustomFetchFn, CustomFetchOptions } from '../../src/client/types';
